define('widgets/dgrid/blocks/curatedContent/curatedContent',['underscore', 'knockout'], function (_, ko) {

    var CuratedContent = function (getFields, games) {
        var self = this;

        self.title = getFields('headline');
        self.description = getFields('description');

        self.textColor = getFields('text_color');
        self.backgroundColor = getFields('background_color');
        self.backgroundImage = getFields('background');
        self.image = getFields('image');

        self.ctaText = getFields('cta_text');
        self.ctaTextColor = getFields('cta_text_color');
        self.ctaButtonColor = getFields('cta_button_color');

        self.callToActionGameSlug = getFields('cta_game');
        self.callToActionRoute = getFields('cta_link');

        self.game = ko.deferredComputed(function () {
            var slug = self.callToActionGameSlug();

            if (slug) {
                slug = slug.join();

                return games.mobileGames.getGameBySlug(slug);
            }

            return undefined;
        });

    };

    return CuratedContent;
});

